import { IApplicationState } from '../../types/redux';
import { removeEmptyKeys } from '../../utils/jsonQuery/removeEmptyKeys';
import { selectPage } from '../analytics';
import { selectQueryString } from '../page';
import { selectSearchTags } from '../tags';

export const selectTrackingPromoTags = (state: IApplicationState) => {
  const page = selectPage(state);
  const tags = selectSearchTags(state);
  const queryString = selectQueryString(state);

  return {
    page,
    tags: tags.map((tag, idx) => ({ position: idx + 1, jsonQuery: removeEmptyKeys(tag.jsonQuery) })),
    sc: queryString,
  };
};
